import { CurrencyDisplay } from "../../../../components";
import { IBalanceData } from "./AvailableAndDisputeBalance";

export const BalanceWithLedgerDisplay = (props: { data: IBalanceData }) => {
  const { data } = props;

  return (
    <>
      <div className="flex-container">
        <span className="text--description flex-box color-light">
          {data.description}
        </span>

        <CurrencyDisplay
          amount={data.availableBalance}
          currencyOrSymbol={data.currency_symbol}
          amountFontSize={18}
          symbolFontSize={10}
          amountClassName={"font-ctm--bold"}
          symbolClassName={"font-ctm--bold"}
        />
      </div>

      <div className="flex-container text--description switchapp-small mt-n5">
        <span className="flex-box color-light">
          On ledger (due to transactions still processing)
        </span>

        <CurrencyDisplay
          amount={data.ledgerBalance}
          currencyOrSymbol={data.currency_symbol}
          amountFontSize={12}
          symbolFontSize={10}
          amountClassName={"font-ctm--bold"}
          symbolClassName={"font-ctm--bold"}
        />
      </div>
    </>
  );
};
